import { request, adminRequest } from "./client";

export const getActiveCampaigns = () =>
  request("/bounty")
    .then((res) => {
      const list = Array.isArray(res) ? res : res?.data;
      return Array.isArray(list) ? list.filter(Boolean) : [];
    })
    .catch(() => []);

export const getMyClaims = () =>
  request("/bounty/mine")
    .then((res) => {
      const list = Array.isArray(res) ? res : res?.data;
      return Array.isArray(list) ? list.filter(Boolean) : [];
    })
    .catch(() => []);

// payload: { walletAddress, proofUrl?, referredProfileId? }
export const claimCampaign = (campaignId, payload) =>
  request(`/bounty/${campaignId}/claim`, {
    method: "POST",
    body: JSON.stringify(payload),
  });

export const getClaimableReferrals = (campaignId) =>
  request(`/bounty/${campaignId}/referrals`)
    .then((res) => {
      const list = Array.isArray(res) ? res : res?.data;
      return Array.isArray(list) ? list.filter(Boolean) : [];
    })
    .catch(() => []);

export const adminGetCampaigns = async (status) => {
  const qs = status ? `?status=${encodeURIComponent(status)}` : "";
  const res = await adminRequest(`/bounty/admin/campaigns${qs}`);
  return Array.isArray(res?.data) ? res.data : Array.isArray(res) ? res : [];
};

export const adminCreateCampaign = (payload) =>
  adminRequest("/bounty/admin/campaigns", {
    method: "POST",
    body: JSON.stringify(payload),
  });

export const adminUpdateCampaign = (id, payload) =>
  adminRequest(`/bounty/admin/campaigns/${id}`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });

export const adminUpdateCampaignPrice = (id, cptPriceUsd) =>
  adminRequest(`/bounty/admin/campaigns/${id}/price`, {
    method: "PATCH",
    body: JSON.stringify({ cptPriceUsd }),
  });

export const adminActivateCampaign = (id) =>
  adminRequest(`/bounty/admin/campaigns/${id}/activate`, { method: "PATCH" });

export const adminPauseCampaign = (id) =>
  adminRequest(`/bounty/admin/campaigns/${id}/pause`, { method: "PATCH" });

export const adminEndCampaign = (id) =>
  adminRequest(`/bounty/admin/campaigns/${id}/end`, { method: "PATCH" });

export const adminGetCampaignStats = async (id) => {
  const res = await adminRequest(`/bounty/admin/campaigns/${id}/stats`);
  return res?.data ?? res ?? {};
};

// Returns raw "address,amount,claimId" CSV text — see PayoutExportDialog,
// which turns this into a downloadable file.
export const adminGetPayoutExport = async (id) => {
  const res = await adminRequest(`/bounty/admin/campaigns/${id}/payout-export`);
  return res?.data ?? res ?? "";
};

// ── Admin: claims ───────────────────────────────────────────────────────

export const adminGetClaims = async ({ status, campaignId } = {}) => {
  const params = new URLSearchParams();
  if (status) params.set("status", status);
  if (campaignId) params.set("campaignId", campaignId);
  const qs = params.toString();
  const res = await adminRequest(`/bounty/admin/claims${qs ? `?${qs}` : ""}`);
  return Array.isArray(res?.data) ? res.data : Array.isArray(res) ? res : [];
};

export const adminRejectClaim = (claimId, reason) =>
  adminRequest(`/bounty/admin/claims/${claimId}/reject`, {
    method: "PATCH",
    body: JSON.stringify({ reason }),
  });

export const adminMarkClaimPaid = (claimId, txHash) =>
  adminRequest(`/bounty/admin/claims/${claimId}/mark-paid`, {
    method: "PATCH",
    body: JSON.stringify({ txHash }),
  });

// ── Admin: fraud flags ──────────────────────────────────────────────────

export const adminGetBountyFlags = async () => {
  const res = await adminRequest("/bounty/admin/flags");
  return Array.isArray(res?.data) ? res.data : Array.isArray(res) ? res : [];
};

export const adminBanBountyAccount = (profileId, reason) =>
  adminRequest(`/bounty/admin/accounts/${profileId}/ban`, {
    method: "POST",
    body: JSON.stringify({ reason }),
  });

export const adminUnbanBountyAccount = (profileId) =>
  adminRequest(`/bounty/admin/accounts/${profileId}/ban`, { method: "DELETE" });
